import { IContact, IGroup } from '../schemas/entity_set'
import { IModelController, ModelController } from '../schemas/structure'
import { IContactService, IContactQuery } from './contact_service';
import { IGroupService } from './group_service';
import { MessageBox } from '../helpers/message_box';
import { IDataUploadService } from '../data_upload/data_upload_service';
import { AppServices } from '../helpers/config_keys';

class ContactsCtrl extends ModelController<IContact> implements IModelController<IContact> {
    groups: IGroup[];
    saving: boolean;
    deleting: boolean;
    //Pager Config
    totalRecords = 0;
    currentPage = 1;
    recordSize = 15;
    totalPages = 1;
    pageNumber = 1;
    lastFilter: IContactQuery;

    static $inject = ["ContactService", "GroupService", AppServices.DataUploadService];

    constructor(private contactService: IContactService,
        private groupService: IGroupService,
        private dataUploadService: IDataUploadService) {
        super("Contact")
        this.start()
    }

    uploadFile() {
        this.dataUploadService.uploadForm("Contact").result.then((action) => {
            if (action) { this.fetch(this.lastFilter) }
        }, () => { })
    }

    pageChanged(page: number) {
        this.currentPage = page;
        this.lastFilter.pager.page = page;
        this.loading = true
        this.contactService.query(this.lastFilter).then((res) => {
            this.loading = false
            if (res.success) {
                this.records = res.data
                this.pageNumber = this.currentPage
            }
        })
    }

    fetch(filter: IContactQuery) {
        filter.pager = filter.pager || { page: 1, size: 15 }
        this.loading = true
        this.lastFilter = angular.copy(filter)
        this.contactService.query(filter).then((res) => {
            this.loading = false
            if (res.success) {
                this.records = res.data
                this.totalRecords = res.total;
                this.totalPages = Math.ceil(res.total / this.recordSize);
                this.pageNumber = this.currentPage
            }
        })
    }

    saveRecord(user: IContact) {
        let theContact = angular.copy(user)
        this.saving = true
        this.contactService.save(theContact).then((res) => {
            this.saving = false
            this.afterSave(theContact, res)
            this.fetch(this.lastFilter)
        })
    }

    deleteRecord(user: IContact) {
        MessageBox.confirm('Delete Contact', `Are you sure you want to delete ${user.name}?`).then((yes) => {
            if (yes) {
                this.deleting = true
                this.contactService.delete(user.id).then((res) => {
                    this.deleting = false
                    this.afterDelete(user, res)
                    this.fetch(this.lastFilter)
                })
            }
        })
    }

    private loadGroups() {
        this.groupService.get().then((res) => {
            if (res.success) { this.groups = res.data }
        })
    }

    private start() {
        this.fetch(<IContactQuery>{})
        this.loadGroups()
    }
}

export { ContactsCtrl }


// WEBPACK FOOTER //
// ./app/address/contacts_ctrl.ts